import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96) translateY(-8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`

const backdropFadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 10, 30, 0.75);
  backdrop-filter: blur(8px);
  z-index: 999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${backdropFadeIn} 0.25s ease-out;
  padding: 20px;
`

export const ModalContainer = styled.div`
  background: #002b80;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);
  border-radius: 20px;
  width: 100%;
  max-width: 720px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${fadeIn} 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  font-family: 'Montserrat', sans-serif;
  color: #ffffff;
`

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 26px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: #001f5c;

  .title-area {
    display: flex;
    align-items: center;
    gap: 14px;

    .icon-box {
      width: 42px;
      height: 42px;
      border-radius: 12px;
      background: rgba(166, 193, 11, 0.15);
      border: 1px solid rgba(166, 193, 11, 0.35);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #a6c10b;
      font-size: 22px;
    }

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
    }

    p {
      margin: 2px 0 0 0;
      font-size: 12px;
      color: #94a3b8;
    }
  }

  .close-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #94a3b8;
    font-size: 22px;
    padding: 6px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(239, 68, 68, 0.15);
      color: #ef4444;
      transform: rotate(90deg);
    }
  }
`

export const TabsNav = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px 26px;
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const TabButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.2s ease;
  background: transparent;
  color: #94a3b8;

  ${({ $active }) =>
    $active
      ? css`
          background: rgba(166, 193, 11, 0.15);
          color: #a6c10b;
          border: 1px solid rgba(166, 193, 11, 0.4);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        `
      : css`
          &:hover {
            color: #ffffff;
            background: rgba(255, 255, 255, 0.05);
          }
        `}
`

export const ModalBody = styled.div`
  padding: 26px;
  overflow-y: auto;
  max-height: calc(90vh - 170px);

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(166, 193, 11, 0.3);
    border-radius: 3px;
  }
`

export const ProfileViewCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;

  .header-card {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .user-summary {
      display: flex;
      align-items: center;
      gap: 16px;

      .avatar {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #001f5c;
        border: 2px solid #a6c10b;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 700;
        color: #ffffff;
        box-shadow: 0 4px 12px rgba(166, 193, 11, 0.25);
      }

      .names {
        h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 700;
          color: #ffffff;
        }
        .badge-role {
          display: inline-block;
          margin-top: 4px;
          padding: 2px 10px;
          background: rgba(166, 193, 11, 0.15);
          border: 1px solid rgba(166, 193, 11, 0.3);
          border-radius: 20px;
          color: #a6c10b;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
        }
      }
    }

    .edit-pencil-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 16px;
      border-radius: 10px;
      background: rgba(166, 193, 11, 0.15);
      border: 1px solid rgba(166, 193, 11, 0.4);
      color: #a6c10b;
      font-size: 13px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: #a6c10b;
        color: #001842;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(166, 193, 11, 0.3);
      }
    }
  }

  .details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);

    .detail-item {
      display: flex;
      flex-direction: column;
      gap: 4px;

      span.label {
        font-size: 11px;
        color: #94a3b8;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-weight: 600;
      }

      span.val {
        font-size: 14px;
        color: #ffffff;
        font-weight: 600;
      }
    }
  }
`

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    font-weight: 600;
    color: #cbd5e1;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    .icon {
      position: absolute;
      left: 14px;
      color: #94a3b8;
      font-size: 16px;
      pointer-events: none;
    }

    input {
      width: 100%;
      height: 44px;
      background: rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(255, 255, 255, 0.15);
      border-radius: 10px;
      padding: 0 40px 0 42px;
      font-size: 14px;
      font-family: 'Montserrat', sans-serif;
      color: #ffffff;
      transition: all 0.2s ease;

      &:focus {
        outline: none;
        border-color: #a6c10b;
        box-shadow: 0 0 0 3px rgba(166, 193, 11, 0.2);
      }

      &::placeholder {
        color: #94a3b8;
        opacity: 0.6;
      }
    }

    .toggle-password {
      position: absolute;
      right: 12px;
      background: transparent;
      border: none;
      color: #94a3b8;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px;
      border-radius: 6px;
      transition: color 0.2s;

      &:hover {
        color: #ffffff;
      }
    }
  }
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 10px;
`

export const ThemeCard = styled.div<{ $selected: boolean; $themeType: string }>`
  border-radius: 14px;
  border: 2px solid ${({ $selected }) => ($selected ? '#a6c10b' : 'rgba(255, 255, 255, 0.1)')};
  background: rgba(0, 0, 0, 0.2);
  box-shadow: ${({ $selected }) =>
    $selected ? '0 0 16px rgba(166, 193, 11, 0.3)' : '0 4px 10px rgba(0, 0, 0, 0.1)'};
  cursor: pointer;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  &:hover {
    transform: translateY(-3px);
    border-color: ${({ $selected }) => ($selected ? '#a6c10b' : 'rgba(166, 193, 11, 0.4)')};
  }

  .preview-box {
    width: 100%;
    height: 90px;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);

    ${({ $themeType }) =>
      $themeType === 'light' &&
      css`
        background: #e8edf2;
        .p-header {
          height: 22px;
          background: #001f5c;
          display: flex;
          align-items: center;
          padding: 0 8px;
          gap: 4px;
          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #a6c10b;
          }
        }
        .p-body {
          flex: 1;
          padding: 8px;
          display: flex;
          gap: 6px;
          .card-sample {
            flex: 1;
            background: #002b80;
            border-radius: 6px;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }
        }
      `}

    ${({ $themeType }) =>
      $themeType === 'dark' &&
      css`
        background: #001842;
        .p-header {
          height: 22px;
          background: #001f5c;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          display: flex;
          align-items: center;
          padding: 0 8px;
          gap: 4px;
          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #3b82f6;
          }
        }
        .p-body {
          flex: 1;
          padding: 8px;
          display: flex;
          gap: 6px;
          .card-sample {
            flex: 1;
            background: #002b80;
            border-radius: 6px;
            border: 1px solid rgba(255, 255, 255, 0.15);
          }
        }
      `}
  }

  .card-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #ffffff;
    }

    .badge-active {
      font-size: 11px;
      font-weight: 700;
      color: #a6c10b;
      background: rgba(166, 193, 11, 0.15);
      padding: 3px 8px;
      border-radius: 6px;
      border: 1px solid rgba(166, 193, 11, 0.3);
    }
  }

  p {
    margin: 0;
    font-size: 12px;
    color: #94a3b8;
    line-height: 1.4;
  }
`

export const MenuOptionCard = styled.div<{ $selected: boolean }>`
  border-radius: 14px;
  border: 2px solid ${({ $selected }) => ($selected ? '#a6c10b' : 'rgba(255, 255, 255, 0.1)')};
  background: rgba(0, 0, 0, 0.2);
  box-shadow: ${({ $selected }) =>
    $selected ? '0 0 16px rgba(166, 193, 11, 0.3)' : '0 4px 10px rgba(0, 0, 0, 0.1)'};
  cursor: pointer;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: ${({ $selected }) => ($selected ? '#a6c10b' : 'rgba(166, 193, 11, 0.4)')};
  }

  .illustration {
    height: 70px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    overflow: hidden;
    position: relative;
    padding: 6px;
    gap: 6px;
  }

  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #ffffff;
    }

    .badge-active {
      font-size: 11px;
      font-weight: 700;
      color: #a6c10b;
      background: rgba(166, 193, 11, 0.15);
      padding: 3px 8px;
      border-radius: 6px;
    }
  }

  p {
    margin: 0;
    font-size: 12px;
    color: #94a3b8;
    line-height: 1.4;
  }
`

export const ColorPreviewBar = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  .chip {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
`

export const AlertMessage = styled.div<{ $type: 'success' | 'error' }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 12px;

  ${({ $type }) =>
    $type === 'success'
      ? css`
          background: rgba(34, 197, 94, 0.15);
          color: #22c55e;
          border: 1px solid rgba(34, 197, 94, 0.3);
        `
      : css`
          background: rgba(239, 68, 68, 0.15);
          color: #ef4444;
          border: 1px solid rgba(239, 68, 68, 0.3);
        `}
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 26px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: #001f5c;

  button {
    height: 42px;
    padding: 0 20px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .cancel-btn {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #ffffff;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }
  }

  .save-btn {
    background: #a6c10b;
    border: none;
    color: #001842;
    font-weight: 700;
    box-shadow: 0 4px 12px rgba(166, 193, 11, 0.3);

    &:hover:not(:disabled) {
      background: #b8d410;
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`
